import {
  light,
  isPropValid,
  isPropNotEqualTo,
  elevation,
  ICssTheme,
  styled,
  css,
  SerializedStyles,
  borderRadius,
  Colors,
  Theme,
} from '@unfold/theme';

import { ICardProps } from './types';

const baseStyles = ({ theme }: ICssTheme): SerializedStyles => css`
  background-color: ${theme?.name === Theme.LIGHT ? Colors.WHITE : Colors.G100};
  border-radius: ${borderRadius.px()({ theme })};
`;

const outlinedStyles = ({ theme = light }: ICssTheme): SerializedStyles => css`
  border: 2px solid ${Colors.G600};
  background-color: transparent;
`;

const squareStyles = (): SerializedStyles => css`
  border-radius: none;
`;

export const StyledCard = styled('div', {
  shouldForwardProp: (prop) =>
    isPropValid(prop) && isPropNotEqualTo(prop, ['elevation', 'square']),
})<ICardProps>`
  ${baseStyles}
  ${(props): (() => SerializedStyles) | null =>
    props.square ? squareStyles : null};
  ${(props) =>
    props.variant === 'outlined'
      ? outlinedStyles
      : props.elevation && elevation};
`;
